import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import {auth} from 'firebase/app';
import {AngularFireAuth} from '@angular/fire/auth';
import{
  AngularFirestore,
  AngularFirestoreDocument
} from '@angular/fire/firestore';
import {Observable, of} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {Users} from '../pages/layout/list/list.component';
import { User } from  'firebase';
import { UsersService } from './users.service'

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  user:  User;

  constructor(
    private afAuth: AngularFireAuth,
    private afs:AngularFirestore,
    private router:Router,
    private usersServiceLocal: UsersService
    ) { }

  async signIn(email, password) {
    return this.afAuth.auth.signInWithEmailAndPassword(email, password)
      .then((result) => {
        localStorage.setItem('currentUser', this.afAuth.auth.currentUser.uid);
        this.usersServiceLocal.getLoginUserData(localStorage.getItem('currentUser')).subscribe( res => {
          localStorage.setItem('currentUserType', res['UserType'] || 'Admin');
          console.log(localStorage.getItem('currentUserType'));
          this.router.navigate(['/pages/maps/gmaps']);
        });
      }).catch((error) => {
        window.alert(error.message)
      })
  }

  async signOut() {
    return this.afAuth.auth.signOut().then(() => {
      this.router.navigate(['/auth']);
      localStorage.removeItem('currentUser');
    })
  }

  loggedIn(): boolean {
    return (localStorage.getItem('currentUser') !== null);
  }

}